import { RECEIVE_NEW_EXPERIMENT_FLAGS } from 'stash/actions/experiments';

type ExperimentsState = Record<string, unknown>;

type ExperimentsAction = {
	type: string;
	payload?: Record<string, unknown>;
};

const experiments = (state: ExperimentsState = {}, action: ExperimentsAction): ExperimentsState => {
	switch (action.type) {
		case RECEIVE_NEW_EXPERIMENT_FLAGS: {
			return {
				...state,
				...action.payload,
			};
		}
		default:
			return state;
	}
};

export default experiments;
